import { Drawer } from '@/components';
import { DrawerState } from '@/components/Drawer/consts';
import { useAppDispatch } from '@/app/hooks';
import { useSmallScreen } from '@/hooks/useWindowDimension';
import { clearItem } from '@/features/analysisMapSlice';
import { updateWorklogStatus } from '@/features/worklogSlice';
import type { Level3ItemProps } from '@/views/list/Level3Item';
import ErrorBoundary from '@/components/ErrorBoundary/ErrorBoundary';
import { useSpanDetailContent } from './SpanDetailContent';
import classes from './SpanMapPopover.module.css';

export const SpanMapPopover = (props: Level3ItemProps) => {
  const { a } = props;
  const dispatch = useAppDispatch();
  const isSmallScreen = useSmallScreen();

  const handleClose = () => {
    dispatch(clearItem());
    dispatch(updateWorklogStatus(false));
  };

  const { getHeader, tabs, scrollingRef } = useSpanDetailContent(a);

  return (
    <ErrorBoundary>
      <div className={classes.wrapper}>
        <Drawer
          hasTabs
          id={`span-${a.level3}`}
          onClose={handleClose}
          scrollingContentRef={scrollingRef}
          renderHeader={
            isSmallScreen
              ? (drawerState, toggleDrawer) =>
                  getHeader({
                    isPreview: drawerState === DrawerState.preview,
                    onToggle: toggleDrawer,
                  })
              : undefined
          }
          header={!isSmallScreen ? getHeader() : undefined}
          height="100dvh"
        >
          {tabs}
        </Drawer>
      </div>
    </ErrorBoundary>
  );
};
